import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/styles/index.css";
import PrismicVue from "@prismicio/vue";

const endpoint = process.env.VUE_APP_PRISMIC_API;
Vue.use(PrismicVue, { endpoint });
Vue.config.productionTip = false;

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount("#app");
